import TeamTable from "./TeamTable";

export default TeamTable;
